import React from 'react';
import { srcSetFor } from '../responsiveImage';

function WineCard({ wine, isAuthenticated, onDelete, onEdit, onImageClick }) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover-lift relative">
      {isAuthenticated && (
        <div className="absolute top-4 right-4 flex gap-2" style={{ zIndex: 10 }}>
          <button onClick={() => onEdit(wine)} aria-label={`Edit ${wine.name}`} className="bg-blue-600 hover:bg-blue-700 text-white w-10 h-10 rounded-full flex items-center justify-center transition shadow-lg">✏️</button>
          <button onClick={() => onDelete(wine.id)} aria-label={`Delete ${wine.name}`} className="bg-red-600 hover:bg-red-700 text-white w-10 h-10 rounded-full flex items-center justify-center transition shadow-lg">✕</button>
        </div>
      )}
      {wine.image ? (
        <button
          type="button"
          onClick={() => onImageClick && onImageClick(wine.image, wine.name)}
          aria-label={`View larger photo of ${wine.name}`}
          className="wine-gradient flex items-center justify-center w-full border-0 p-0"
          style={{ height: '18rem', overflow: 'hidden', cursor: 'pointer' }}
        >
          <img
            src={wine.image}
            srcSet={srcSetFor(wine.image)}
            sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
            alt={wine.name}
            loading="lazy"
            decoding="async"
            width="600"
            height="800"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </button>
      ) : (
        <div
          className="wine-gradient flex items-center justify-center text-white text-7xl"
          style={{ height: '18rem', overflow: 'hidden' }}
          aria-hidden="true"
        >
          {wine.emoji}
        </div>
      )}
      <div className="p-6">
        <h3 className="text-2xl font-bold text-wine mb-2">{wine.name}</h3>
        <p className="text-gold-dark italic mb-4">{wine.type}</p>
        <p className="text-gray-600 mb-4">{wine.description}</p>
        <div className="text-2xl font-bold text-wine">{wine.price}</div>
      </div>
    </div>
  );
}

export default WineCard;
